import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_3 = { class: "mt-2 text-sm text-gray-600" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger mt-2 text-sm"
}
const _hoisted_5 = { class: "mt-6 flex justify-end gap-3" }

import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { MetaPhoneNumber } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppMetaPhoneActivationDialog',
  props: {
    phone: {},
    isSubmitting: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();

const emit = __emit;

const pin = ref('');
const isValid = computed(() => /^\d{6}$/.test(pin.value));

watch(
    () => props.phone,
    () => {
        pin.value = '';
    },
);

const close = () => {
    if (props.isSubmitting) return;
    pin.value = '';
    emit('close');
};

const submit = () => {
    if (!isValid.value || props.isSubmitting) return;
    emit('confirm', pin.value);
};

return (_ctx: any,_cache: any) => {
  const _component_UiTextInput = _resolveComponent("UiTextInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: Boolean(_ctx.phone)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-50",
        onClose: close
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-200",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-150",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75" }, null, -1)
            ])),
            _: 1,
            __: [1]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-200",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-150",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "w-full max-w-md rounded-lg bg-white p-6 shadow-xl" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogTitle), { class: "text-lg font-semibold text-gray-800" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.activationDialog.title')), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("p", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.activationDialog.descriptionBeforeNumber')) + " ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.phone?.displayPhoneNumber || _ctx.phone?.phoneNumberId), 1),
                        _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.activationDialog.descriptionAfterNumber')), 1)
                      ]),
                      _createElementVNode("form", {
                        class: "mt-5",
                        onSubmit: _withModifiers(submit, ["prevent"])
                      }, [
                        _createVNode(_component_UiTextInput, {
                          modelValue: pin.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pin).value = $event)),
                          label: _unref(t)('whatsappMeta.activationDialog.pinLabel'),
                          name: "whatsapp-registration-pin",
                          type: "password",
                          inputmode: "numeric",
                          maxlength: "6",
                          autocomplete: "new-password",
                          placeholder: "000000"
                        }, null, 8, ["modelValue", "label"]),
                        (pin.value && !isValid.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('whatsappMeta.activationDialog.invalidPin')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_UiButton, {
                            variant: "white",
                            "text-variant": "primary",
                            onClick: close
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.activationDialog.cancel')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_UiButton, {
                            "html-type": "submit",
                            variant: "primary",
                            "text-variant": "white",
                            disabled: !isValid.value || _ctx.isSubmitting
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.activationDialog.activate')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ], 32)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})